<template>
  <v-container class="p-plan px-0">
    <v-layout>
      <v-flex grow class="left-section">
        <c-section title="保费试算">
          <h3>诚泰团体人身意外伤害保险</h3>
          <v-layout class="form-section">
            <v-flex class="form-item form-item-left">
              <label class="form-item-label">保障期限</label>
              <v-select v-model="form.effectDuration" solo single-line :items="effectDurationList"></v-select>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>
          <v-layout class="plan-section">
            <v-flex>
              <v-layout align-center>
                <v-flex class="subheading">保障方案</v-flex>
                <v-flex shrink>
                  <v-btn color="primary" flat @click="categoryFindVisible=true">查看职业分类</v-btn>
                </v-flex>
              </v-layout>
              <InsurancePlanTable
                v-model="amount"
                :code="code"
                :plan-id="form.planId"
                :effect-duration="form.effectDuration"
                :plan-list.sync="planList"
              ></InsurancePlanTable>
            </v-flex>
          </v-layout>
        </c-section>
      </v-flex>
      <v-flex shrink class="right-section">
        <div class="pay-card app-bg">
          <div>
            总保费
            <span class="display-1 primary-text">￥{{ amount.toFixed(2) }}</span>
          </div>
        </div>
      </v-flex>
    </v-layout>

    <CategoryFind v-model="categoryFindVisible"></CategoryFind>
  </v-container>
</template>

<script>
import InsurancePlanTable from "@/components/Order/InsurancePlanTable";
import CategoryFind from "@/components/Order/CategoryFind";
export default {
  components: {
    InsurancePlanTable,
    CategoryFind
  },
  props: {
    code: String
  },
  data() {
    return {
      categoryFindVisible: false,
      effectDurationList: [
        { text: "1年", value: 12 },
        { text: "11个月", value: 11 },
        { text: "10个月", value: 10 },
        { text: "9个月", value: 9 },
        { text: "8个月", value: 8 },
        { text: "7个月", value: 7 },
        { text: "6个月", value: 6 },
        { text: "5个月", value: 5 },
        { text: "4个月", value: 4 },
        { text: "3个月", value: 3 },
        { text: "2个月", value: 2 },
        { text: "1个月", value: 1 }
      ],
      form: {
        // 保障期限
        effectDuration: 12,
        // 产品方案
        planId: 4
      },
      planList: [],
      amount: 0
    };
  },
  computed: {
    product() {
      return this.$store.getters.getProduct(this.code);
    }
  }
};
</script>

<style lang="scss" scoped>
.p-plan {
  .left-section {
    .form-section {
      padding: 30px 137px 40px 0;
      .form-item {
        width: 245px;
        flex-grow: 0;
        .form-item-label {
          width: 56px;
        }
      }
    }
    .plan-section {
      padding: 20px 0;
    }
  }
  .right-section {
    width: 330px;
    margin-left: 20px;
    .pay-card {
      width: 330px;
      padding: 40px 25px;
    }
  }
}
</style>

